import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { PublicUserEntity } from './public-user.entity';
import { SelectableResourceConfigurationEntity } from './selectable-resource-configuration.entity';

@Index(
	'_fk__selectable_resource_configuration__id',
	['fkSelectableResourceConfigurationId'],
	{},
)
@Index(
	'unique_selectable_resource_resource',
	[
		'fkPublicUserId',
		'selectableResourceId',
		'fkSelectableResourceConfigurationId',
	],
	{ unique: true },
)
@Entity('_public_user_selectable_resource')
export class PublicUserSelectableResourceEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__public_user__id',
		nullable: true,
		unsigned: true,
	})
	public fkPublicUserId!: number | null;

	@Column('int', {
		name: '_selectableResourceId',
		nullable: true,
		unsigned: true,
	})
	public selectableResourceId!: number | null;

	@Column('tinyint', {
		name: '_isSelected',
		nullable: true,
		default: () => "'0'",
	})
	public isSelected!: number | null;

	@Column('int', {
		name: '_fk__selectable_resource_configuration__id',
		nullable: true,
		unsigned: true,
	})
	public fkSelectableResourceConfigurationId!: number | null;

	@ManyToOne(
		() => PublicUserEntity,
		(publicUser) => publicUser.publicUserSelectableResources,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: '_fk__public_user__id', referencedColumnName: 'id' }])
	public fkPublicUser!: PublicUserEntity;

	@ManyToOne(
		() => SelectableResourceConfigurationEntity,
		(selectableResourceConfiguration) =>
			selectableResourceConfiguration.publicUserSelectableResources,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{
			name: '_fk__selectable_resource_configuration__id',
			referencedColumnName: 'id',
		},
	])
	public fkSelectableResourceConfiguration!: SelectableResourceConfigurationEntity;
}
